export function DislikeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.277 19.613a.5.5 0 01-.554 0l-.148-.098a.767.767 0 01-.307-.41L8 11.847V4h9.086c.26 0 .506.123.663.331l.183.245a.476.476 0 01-.044.622 1.134 1.134 0 000 1.604l.236.237c.343.342.396.878.127 1.281a1.183 1.183 0 00.148 1.493l.225.226c.343.342.396.878.127 1.281a1.183 1.183 0 00.148 1.493l.273.273a.828.828 0 01-.586 1.414H12.5a1 1 0 00-1 1v3.697a.5.5 0 01-.223.416zM6 4v7H4V4h2zm.265 9l2.094 6.702c.189.604.58 1.125 1.106 1.477l.148.098a2.5 2.5 0 003.887-2.08V16.5h5.086a2.828 2.828 0 002.141-4.676 3.017 3.017 0 00-.502-2.995 3.018 3.018 0 00-.432-2.916 2.476 2.476 0 00-.261-2.537l-.183-.245A2.828 2.828 0 0017.086 2H3a1 1 0 00-1 1v9a1 1 0 001 1h3.265z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
